module.exports = __webpack_public_path__ + "img/Platform_Gradients-5.62a67bae.jpg";